import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { QuoteStatus } from '@models/quotes';

export interface QuoteStatusTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

const quoteStatus = [
  QuoteStatus.Submission,
  QuoteStatus.Rated,
  QuoteStatus.Referred,
  QuoteStatus.Underwritten,
  QuoteStatus.ReadyToBind,
];
const options = quoteStatus.map((status) => ({
  key: status.id,
  label: status.name,
  value: status.queryParam,
}));

export const QuoteStatusTypeaheadFilter = (componentProps: QuoteStatusTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={options}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
